import React, { useEffect, useState } from 'react';
import { useError } from '../hooks/useError';
import { Notification } from '~/shared/components/Notifications';
import { useTranslation } from '~/shared/utils/translation';
import { StyledContent } from './styled';

type Props = {
    description?: string;
};

export const ErrorBoundaryFallback = ({ description }: Props) => {
    const { error } = useError();
    const { translate } = useTranslation();
    const [dismiss, setDismiss] = useState(false);

    useEffect(() => {
        console.info(`%cuse${error?.message}`, 'color: #eed202');
    }, [error?.message]);

    return (
        <>
            {!dismiss && (
                <StyledContent>
                    <Notification
                        onDismiss={() => setDismiss(true)}
                        text={description || translate('message.contentUnavailable')}
                        duration={0}
                    />
                </StyledContent>
            )}
        </>
    );
};
